import React, { useEffect, useState } from "react";
import Dashboard from "./dashboard";
import axios from "../api/baseurl";
import "./Spinner.css";
import "./Loader.css";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import CreateLabCorporate from "./addLabCorporate";
import { Pagination } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

function LabCorporateDetails() {
  const [labCorporateDetails, setLabCorporateDetails] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("data")).token;

  useEffect(() => {
    if (searchTerm.trim()) {
      searchData(0);  
    } else {
      getData(currentPage);   
  }
  }, [searchTerm]); 


  const searchData = async (pageNumber = 0) => {
    setLoader(true);
     try {
            const searchUrl = `/api/lab-corporate/searchByNameOrEmailOrOrgcode`;
                     const requestData = {
                       searchTerm
                     };
               
             const response = await axios.post(searchUrl, requestData, {
               params: { page: pageNumber},
               headers: { Authorization: `Bearer ${token}` },
             });
             setLabCorporateDetails(response.data.content);
             setCurrentPage(response.data.number);
             setTotalPages(response.data.totalPages);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const getData = async (pageNumber = 0) => {
    setLoader(true);
    try {
      const token = JSON.parse(localStorage.getItem("data")).token;
      const trans = await axios.get(`/api/lab-corporate/getAll`, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });

      setLabCorporateDetails(trans.data.content);
      setCurrentPage(trans.data.number);
      setTotalPages(trans.data.totalPages);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  
    if (searchTerm.trim()) {
      searchData(newPage);
    } else {
      getData(newPage);
    }
  };
  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };


  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

 
  const handleAdd = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    getData();
  };

  const handleClick = (orgcode) => {
    navigate(`/users/lab-corporate-profile/${orgcode}`);
  };

  const handleViewLabs = (corporateId) => {
    navigate(`/users/corporate-labs/${corporateId}`);
  };


  return (
    <div>
      <div>
        <Dashboard />
      </div>
      <div>
      {loader && <div className="loading"></div>}
        <div className="col-12 mx-xl-auto ps-xl-10 mt-10">
          <div className="card card-raised ">
            <div className="card-body ">
            <div className="card-title form-group d-flex align-items-center justify-content-between">
              <span>Lab Corporate Details</span>
              <div className="form-group position-relative" style={{ width: "300px" }}>
                <input
                  type="search"
                  className="form-control"
                  placeholder="Search by name, email or orgcode"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ paddingLeft: "2rem", width: "100%" }}
                />
                <span className="position-absolute" style={{ left: "10px", top: "50%", transform: "translateY(-50%)" }}>
                  <FontAwesomeIcon icon={faSearch} />
                </span>
              </div>
              <div>
               
                <button className="btn btn-primary" onClick={handleAdd}>
                  ADD
                </button>
              </div>
            </div>

              <br />
              <table className="table table-bordered">
                <thead>
                  <tr className="table-header">
                    <th>Email</th>
                    <th>Name</th>
                    <th>Orgcode</th>
                    <th>Contact</th>
                    <th>Client Code</th>
                    <th>Admin Link</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {labCorporateDetails.length === 0 ? (
                    <tr>
                      <td colSpan="10" className="text-center">
                        No Data Available
                      </td>
                    </tr>
                  ) : (
                    labCorporateDetails.map((accd) => (
                      <tr key={accd.id}>
                        <td
                          style={{ cursor: "pointer" }}
                          onClick={() => handleClick(accd.orgcode)}
                          onMouseOver={(e) => {
                            e.target.style.color = "blue";
                            e.target.style.textDecoration = "underline";
                          }}
                          onMouseOut={(e) => {
                            e.target.style.color = "";
                            e.target.style.textDecoration = "";
                          }}
                        >
                          {accd.email}
                        </td>
                        <td>{accd.name}</td>
                        <td>{accd.orgcode}</td>
                        <td>{accd.contact}</td>
                        <td>{accd.clientId}</td>
                        <td>{accd.adminEmail}</td>
                        <td style={{ fontSize: "17px", cursor: "pointer" }}>
                          <div>
                          <button
                            className="btn btn-primary"
                            onClick={() => handleViewLabs(accd.id)}
                          >
                            View Labs
                          </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
              <div className="d-flex justify-content-center">
              <Pagination>
                <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                {renderPageNumbers()}
                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
              </Pagination>
            </div>

              <div>
                {isModalOpen && (
                  <CreateLabCorporate
                    isOpen={isModalOpen}
                    onRequestClose={handleCloseModal}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {loader && <div className="loading"></div>}
      </div>
    </div>
  );
}

export default LabCorporateDetails;
